import HttpFactory from '@/mixins/http.factory';
export default {
	name:'configure-app',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			configData:null,
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', async (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
				await _self.getConfigData();
			});
		},
		async getConfigData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`userData/get`;
			let data={auth:_self.zendeskInfo.credentials};
			let response=await _self.post(url,data);
			_self.fn().showLoader(false);
			let configData=response.data.Data;
			_self.configData=configData;
		},
		saveConfigDataFn(){
			let _self=this;
			_self.fn().clearMessage();
			let url=`userData/update`;
			let data=_self.configData;
			
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			_self.fn().showLoader(true);
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let data=response.data.Data;
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Customize View data saved Successfully`]}
					_self.userMsg=userMsg;
				}
				//_self.sendDataToParent(response.data);
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		}
	}
}

